import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to /login on 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.replace('/login');
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (nombre_usuario, contrasena) =>
  api.post('/api/auth/login', { nombre_usuario, contrasena });

export const getMe = () => api.get('/api/auth/me');

// Empresa (public)
export const getEmpresa = () =>
  axios.get(`${API_URL}/api/empresa`);

// Config
export const getConfig = (path, businessId) =>
  api.get(`/api/config/${path}?business_id=${businessId}`);

export const createConfig = (path, businessId, data) =>
  api.post(`/api/config/${path}?business_id=${businessId}`, data);

export const updateConfig = (path, id, businessId, data) =>
  api.put(`/api/config/${path}/${id}?business_id=${businessId}`, data);

export const deleteConfig = (path, id, businessId) =>
  api.delete(`/api/config/${path}/${id}?business_id=${businessId}`);

export const getEmpresaInfo = (businessId) =>
  api.get(`/api/config/empresa?business_id=${businessId}`);

export const getMovementCauseTypes = (businessId, applies_to = '', manualOnly = false) => {
  let url = `/api/config/tipos-movimiento?business_id=${businessId}`;
  if (applies_to) url += `&applies_to=${applies_to}`;
  if (manualOnly) url += `&manual_only=true`;
  return api.get(url);
};

export default api;
